module.exports = __webpack_public_path__ + "static/media/blog-29-image-2.3e32a566.webp";